<script>
  // Mount once near the app root. Owns the global Snackbar + ConfirmDialog.
  import Snackbar from './Snackbar.svelte';
  import ConfirmDialog from './ConfirmDialog.svelte';
</script>

<Snackbar />
<ConfirmDialog />
